// extracted by mini-css-extract-plugin
export var active = "_2r-d";
export var blink = "_2r-e";
export var container = "_2r-5";
export var controls = "_2r-0";
export var controlsRight = "_2r-1";
export var fakeCursor = "_2r-c";
export var hidden = "_2r-b";
export var quillContainerSmall = "_2r-7";
export var quillEditor = "_2r-6";
export var quillEditorSmall = "_2r-8";
export var quillFormatButtons = "_2r-a";
export var quillToolbar = "_2r-9";
export var removePadding = "_2r-2";
export var state = "_2r-3";
export var stateTitle = "_2r-4";